<template>
  <el-button
    v-bind="$attrs"
    @click="handleButtonClick"
  >
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  name: 'YhButton',

  methods: {
    handleButtonClick: _.debounce(function debounced() {
      this.$emit('click');
    }, 500),
  },
};
</script>
